import Vue from 'vue'
import VueRouter from 'vue-router'
import Rent from '../views/search/Rent'
import Centre from '../views/search/Centre'
import Space from '../views/search/Space'
import Cart from '../views/search/Cart'
import PageNotFound from '../views/PageNotFound'

import Rails from "@rails/ujs"

Vue.use(VueRouter)
Rails.start()

// Get locale from a global JavaScript variable passed in the layout
const getLocaleFromRails = () => {
  const defaultLocale = 'en'; // Default to 'en' if not set
  return window.appLocale || defaultLocale;
};

const routes = [
  {
    path: '/:locale(en|es|it)?/search',  // Only "es" locale is allowed in the URL
    name: 'Rent',
    component: Rent
  },
  {
    path: '/:locale(en|es|it)?/search/centre/:slug',
    name: 'Centre',
    component: Centre
  },
  {
    path: '/:locale(en|es|it)?/search/space',
    name: 'Space',
    component: Space
  },
  {
    path: '/:locale(en|es|it)?/search/space/:slug',
    name: 'SpaceSlug',
    component: Space
  },
  {
    path: '/:locale(en|es|it)?/search/cart',
    name: 'Cart',
    component: Cart
  },
  {
    path: '*',
    name: 'PageNotFound',
    component: PageNotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// Route guard to handle locales
router.beforeEach((to, from, next) => {
  const locale = getLocaleFromRails();

  if (to.name === 'PageNotFound') {
    next();
  } else {
    if ((locale === 'es' || locale === 'it') && !to.params.locale) {
      next({ path: `/${locale}${to.path}` });
    } else if (locale === 'en' && to.params.locale) {
      next({ path: to.path.replace(/^\/(en|es|it)/, '') });
    } else {
      next();
    }
  }
});

export default router;